module.exports = __webpack_public_path__ + "media/mypage/images/banner_interviews_sp-ab5682edc65d67e1908e57fee807b08a.png";